"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_web_components_1 = require("@nimles/react-web-components");

var styled_1 = __importDefault(require("@emotion/styled"));

var ImageInformation_1 = require("./ImageInformation");

var Images = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 10px;\n"], ["\n  margin-bottom: 10px;\n"])));
var ImageButton = styled_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  border: 1px solid lightgrey;\n  border-radius: 2px;\n  padding: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: ", ";\n  background-color: ", ";\n\n  &::hover > div {\n    display: block;\n  }\n"], ["\n  position: relative;\n  border: 1px solid lightgrey;\n  border-radius: 2px;\n  padding: 0;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: ", ";\n  background-color: ", ";\n\n  &::hover > div {\n    display: block;\n  }\n"])), function (_a) {
  var isSelected = _a.isSelected;
  return isSelected ? '2px solid green' : '1px solid lightgrey';
}, function (_a) {
  var isSelected = _a.isSelected;
  return isSelected ? 'lightgreen' : '#efefef';
});
var Image = styled_1.default.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));

exports.ImageGrid = function (_a) {
  var selected = _a.selected,
      onSelect = _a.onSelect,
      images = _a.images;
  return react_1.default.createElement(Images, null, react_1.default.createElement(react_web_components_1.Row, {
    wrap: true
  }, images && images.map(function (image) {
    var _a;

    return react_1.default.createElement(react_web_components_1.Column, {
      padding: true,
      xs: 100,
      sm: 50,
      md: 33,
      lg: 25
    }, react_1.default.createElement(ImageButton, {
      isSelected: selected === image.id,
      onClick: function onClick(e) {
        e.preventDefault();
        onSelect(image);
      }
    }, react_1.default.createElement(ImageInformation_1.ImageInformation, {
      image: image
    }), react_1.default.createElement(Image, {
      src: (_a = image.thumbnailUri, _a !== null && _a !== void 0 ? _a : "https://media.nimles.com/file/" + image.tenantId + "/" + image.id + "?width=480")
    })));
  })));
};

var templateObject_1, templateObject_2, templateObject_3;